import React from "react";

function HelpMenu() {
  return (
    <div
      className="help-menu"
      style={{
        zIndex: "6",
        width: "350px",
        height: "440px",
        backgroundColor: "#d9d9d9",
        position: "absolute",
        borderRadius: "45px",
        padding: "40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        fontFamily: "Jua, sans-serif",
        textAlign: "center",
        left: "50%",
        top: "calc(50% - 45px)",
        transform: "translate(-50%, -50%)",
      }}
    >
      <h2>need help?</h2>
      <p>
        roygbv is a memory game.
        <br />
        you have a limited amount of time to memorize the pattern of colored
        tiles before they fade.
      </p>
      <p>to succeed, select the tiles in the following order:</p>
      <div
        style={{
          backgroundColor: "#2f2f2f",
          height: "75px",
          width: "250px",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            gridTemplateRows: "1fr",
            columnGap: "6px",
          }}
        >
          <div
            style={{
              height: "30px",
              width: "30px",
              backgroundColor: "#ff3939",
              borderRadius: "8px",
            }}
          ></div>
          <div
            style={{
              height: "30px",
              width: "30px",
              backgroundColor: "#f0884e",
              borderRadius: "8px",
            }}
          ></div>
          <div
            style={{
              height: "30px",
              width: "30px",
              backgroundColor: "#ffd130",
              borderRadius: "8px",
            }}
          ></div>
          <div
            style={{
              height: "30px",
              width: "30px",
              backgroundColor: "#8ade63",
              borderRadius: "8px",
            }}
          ></div>
          <div
            style={{
              height: "30px",
              width: "30px",
              backgroundColor: "#558fff",
              borderRadius: "8px",
            }}
          ></div>
          <div
            style={{
              height: "30px",
              width: "30px",
              backgroundColor: "#9666fc",
              borderRadius: "8px",
            }}
          ></div>
        </div>
      </div>
      <p>good luck! :D</p>
    </div>
  );
}

export default HelpMenu;
